import type { Messages, DeepPartial } from './fr'

// Phase 1 : vide → fallback FR au runtime. Rempli en Phase 2.
export const nl: DeepPartial<Messages> = {
  legalLayout: {
    home: 'Home',
    lastUpdated: 'Laatst bijgewerkt',
  },
  footer: {
    tagline:
      'Jouw platform om je volledige e-commerce logistiek te beheren. Magazijn in het hart van Europa.',
    colProduct: 'Product',
    colCompany: 'Bedrijf',
    colResources: 'Bronnen',
    colLegal: 'Juridisch',
    linkSectors: 'Sectoren',
    linkFulfillment: 'DNVB & D2C fulfilment',
    linkPricing: 'Tarieven',
    linkStorage: 'Opslag',
    linkPickpack: 'Pick & Pack',
    linkShipping: 'Levering volgende dag',
    linkReturns: 'Retourzendingen',
    linkCarriers: 'Vervoerders',
    linkAdr: 'ADR-opslag',
    linkAfsca: 'FAVV-opslag',
    linkAbout: 'Over ons',
    linkBlog: 'Blog',
    linkContact: 'Contact',
    linkFaq: 'FAQ',
    linkIntegrations: 'Integraties',
    linkTestimonials: 'Referenties',
    linkLegalNotice: 'Juridische kennisgeving',
    linkTerms: 'Algemene voorwaarden',
    linkPrivacy: 'Privacybeleid',
    linkCookies: 'Cookiebeleid',
    socialAria: 'Yaslan op {name}',
    manageCookies: 'Cookies beheren',
    systemsOperational: 'Alle systemen operationeel',
  },
  nav: {
    cta: 'Praat met een expert',
    openMenu: 'Menu openen',
    closeMenu: 'Menu sluiten',
    menuServices: 'Diensten',
    menuSecteurs: 'Sectoren',
    menuRessources: 'Bronnen',
    menuExpertises: 'Expertise',
    colParService: 'Per dienst',
    colOutils: 'Hulpmiddelen',
    colModeBeaute: 'Mode & Beauty',
    colMaisonOutdoor: 'Huis & Outdoor',
    colLecture: 'Lezen',
    colSociete: 'Bedrijf',
    storageLabel: 'Opslag',
    storageDesc: 'Flexibel Europees magazijn',
    pickpackLabel: 'Pick & Pack',
    pickpackDesc: 'Orderverwerking in jouw huisstijl',
    shippingLabel: 'Levering volgende dag',
    shippingDesc: 'Cut-off om 15u, morgen geleverd',
    returnsLabel: 'Retourzendingen',
    returnsDesc: 'White-label portaal',
    fulfillmentLabel: 'DNVB & D2C fulfilment',
    fulfillmentDesc: 'Logistiek voor D2C-merken',
    pricingLink: 'Tarieven',
    integrationsLabel: 'Integraties',
    integrationsDesc: 'Shopify, WooCommerce, Amazon',
    carriersLabel: 'Vervoerders',
    carriersDesc: '30+ partners vergeleken',
    modeLabel: 'Mode & Textiel',
    modeDesc: 'Drops, retourzendingen, branding',
    cosmetiqueLabel: 'Cosmetica & Beauty',
    cosmetiqueDesc: 'Batches, CLP-naleving, kits',
    parfumerieLabel: 'Parfumerie',
    parfumerieDesc: 'ADR, flacons, geschenksets',
    maisonLabel: 'Huis & Decoratie',
    maisonDesc: 'Breekbaarheid, multi-pakket',
    jardinLabel: 'Tuin & Buiten',
    jardinDesc: 'Volumes, sterk seizoensgebonden',
    electroniqueLabel: 'Elektronica & High-Tech',
    electroniqueDesc: 'Serialisatie, RMA, ADR',
    blogLabel: 'Blog',
    blogDesc: 'Casestudy’s en gidsen',
    faqLabel: 'FAQ',
    faqDesc: 'Veelgestelde vragen',
    aboutLabel: 'Over ons',
    aboutDesc: 'Onze bestaansreden',
    contactLabel: 'Contact',
    contactDesc: 'Praat met een expert',
    colExpertise: 'Vergunningen & mogelijkheden',
    adrLabel: 'ADR — Gevaarlijke goederen',
    adrDesc: 'Opslag & verzending onder ADR-vergunning',
    afscaLabel: 'FAVV — Voeding',
    afscaDesc: 'FAVV-geregistreerde opslag op kamertemperatuur',
  },
  hero: {
    badgeAutopilot: 'Logistiek op de automatische piloot',
    badgeWarehouse: 'Magazijn in het hart van Europa',
    headlineLine1Part1: 'Jouw',
    headlineLine1Part2: 'e-commerce',
    headlineLine1Part3: 'logistiek,',
    headlineLine2Part1: 'vlot, betrouwbaar',
    headlineLine2Part2: 'en',
    headlineLine2Part3: 'discreet.',
    subhead:
      'Opslag, pick & pack, verzending binnen 24u via 30+ vervoerders en retourbeheer — zonder abonnement, zonder gedoe. Jouw pakketten, jouw merk, onze logistiek.',
    ctaPrimary: 'Offerte aanvragen',
    ctaSecondary: 'Bereken je tarief',
    ctaReassurance: 'Gratis audit in 2 minuten · Geen abonnement',
    trustDelivery: 'Levering in 1-2 dagen',
    trustAllLevels: 'Geschikt voor beginners én experts',
    trustNoCommitment: 'Geen verplichting',
    trustReturns: 'Retouren 100% geautomatiseerd',
  },
  cta: {
    badge: 'Gratis logistieke audit',
    headlinePart1: 'Klaar om',
    headlinePart2: 'je logistiek uit te besteden',
    subhead:
      'Praat met een Yaslan-expert. We analyseren je huidige setup, tonen je hoeveel je kunt besparen en zetten je binnen 15 minuten live.',
    ctaPrimary: 'Boek een gesprek van 30 min',
    ctaSecondary: 'Ontdek de diensten',
    trustResponse: 'Antwoord binnen 24 werkuren',
    trustPayAsYouGo: 'Betalen per gebruik',
    trustOnboarding: 'Onboarding van 15 min',
    trustSupport: 'EN/FR-ondersteuning 7u-22u',
  },
  closing: {
    badge: 'Onze belofte · Onzichtbare logistiek',
    headlinePart1: 'Logistiek die',
    headlinePart2: 'op de achtergrond verdwijnt',
    subhead:
      'De beste e-commerce logistiek is degene die niemand opmerkt, behalve jij. Drie beloften die elke keuze die we maken sturen, van de eerste ontvangen doos tot de laatste leveringsmelding.',
    promiseInvisibleTitle: 'Discreet',
    promiseInvisibleDesc:
      'Je klanten zien onze naam nooit. Verpakking, retourportaal en e-mails blijven in jouw merk, van de doos tot de bevestigingsmail.',
    promiseFlexibleTitle: 'Flexibel',
    promiseFlexibleDesc:
      'Geen abonnement, geen langetermijnverbintenis, geen minimum. Je betaalt voor wat je werkelijk verzendt, en je tarief groeit mee met je activiteit.',
    promiseHumanTitle: 'Menselijk',
    promiseHumanDesc:
      'Een team in België, rechtstreeks bereikbaar in het Engels of het Frans, dat je producten en je beperkingen kent — geen chatbot, geen ticket.',
  },
  stats: {
    eyebrow: 'Concrete cijfers',
    headline: 'Logistiek die je groei volgt.',
    shippingLabel: 'Max. verzending',
    shippingSub: 'Bestellingen vóór 15u',
    carriersLabel: 'Vervoerders',
    carriersSub: 'GLS, bpost, DPD, UPS...',
    platformsLabel: 'Platformen',
    platformsSub: 'Shopify, WooCommerce, Odoo',
    savingsLabel: 'Transparantie',
    savingsSub: 'Transport + pick & pack, meer niet',
  },
  brands: {},
  carriers: {
    badgeLabel: 'Vervoerders',
    badgeCount: '+30 native integraties',
    headlinePart1: 'Eén integratie,',
    headlinePart2: '+30 vervoerders',
    headlinePart3: 'nul gedoe.',
    subhead:
      'Bpost, DHL, GLS, UPS, DPD… Wij vergelijken de tarieven en maken de labels aan. Jij volgt elk pakket vanuit één dashboard.',
    featured: 'Uitgelicht',
    negotiatedRates: 'Onderhandelde tarieven',
    moreCarriersLine1: 'Nog meer',
    moreCarriersLine2: 'vervoerders',
    zoneWorld: 'Wereld',
    leadBpost: 'Standaard en snelle levering (24u) in België.',
    leadGls:
      'Betrouwbare pakketlevering met een sterke Europese B2C- en B2B-dekking.',
    leadDhl: 'De specialist in internationale expreslevering.',
    leadDpd:
      'Sterk Europees netwerk met flexibele leveringsopties.',
    leadPostnl:
      'De belangrijkste operator voor je verzendingen naar Nederland en de Benelux.',
    leadUps: 'Snel wereldwijd transport met zeer nauwkeurige tracking.',
    leadFedex: 'Wereldwijde expreslevering voor je dringende verzendingen.',
    leadMondialrelay:
      'Voordelige oplossing gespecialiseerd in levering via afhaalpunten.',
    leadColisprive: 'Thuislevering geoptimaliseerd voor e-commerce.',
    leadDeutschepost:
      'Klassieke en voordelige postdienst voor Duitsland en het buitenland.',
    leadDsv:
      'Wereldwijde logistieke oplossingen en vrachttransport (weg, zee, lucht).',
  },
  services: {
    badgeLabel: 'Diensten',
    badgeTagline: 'End-to-end logistiek',
    headlinePart1: 'Eén platform dat',
    headlinePart2: 'je volledige logistiek beheert',
    subhead:
      'Van de ontvangst van het product tot de uiteindelijke levering — en daarna met retourzendingen — dekt Yaslan elke stap, op de automatische piloot.',
    learnMore: 'Meer informatie',
    storageTitle: 'Opslag',
    storageDesc:
      'Gecentraliseerde e-commerce opslag in het hart van Europa, schaalbaar zonder minimumvolume.',
    storageBullet1: 'Ontvangst & controle',
    storageBullet2: 'Voorraad in realtime',
    storageBullet3: 'Rekken, pallets & pickbakken',
    pickpackTitle: 'Pick & Pack',
    pickpackDesc:
      'Geautomatiseerde orderverwerking met verpakkingen 100% aanpasbaar aan jouw merk.',
    pickpackBullet1: 'Branding op maat',
    pickpackBullet2: 'Promo-inserts',
    pickpackBullet3: 'Orderverwerking < 4 u',
    shippingTitle: 'Levering volgende dag',
    shippingDesc:
      '30+ vervoerders automatisch vergeleken. Bestellingen vóór 15u dezelfde dag verzonden.',
    shippingBullet1: 'Cut-off om 15u',
    shippingBullet2: 'Slimme routing',
    shippingBullet3: 'Gebundelde tracking',
    returnsTitle: 'Beheerde retourzendingen',
    returnsDesc:
      'Volledige verwerking volgens jouw regels. Terugplaatsing in voorraad, terugbetaling of doorverkoop.',
    returnsBullet1: 'White-label klantenportaal',
    returnsBullet2: 'Aanpasbare regels',
    returnsBullet3: 'Terug in voorraad binnen 24 u',
  },
  features: {
    badgeLabel: 'Waarom Yaslan',
    badgeTagline: 'Onzichtbare logistiek',
    headlinePart1: 'Nul gedoe.',
    headlinePart2: 'Nul toezicht.',
    subhead:
      'Logistiek ontworpen om te verdwijnen: jij verkoopt, wij leveren — je klanten zien alleen jouw merk.',
    carriersName: '30+ vervoerders',
    carriersDesc:
      'GLS, bpost, DPD, UPS, DHL, PostNL… automatisch vergeleken en geselecteerd, bestelling per bestelling.',
    carriersHighlight: 'Multi-carrier',
    carriersCta: 'Bekijk de integraties',
    tariffName: 'Tarieven afgestemd op je volume',
    tariffDesc:
      'Of je nu 100 of 5.000 pakketten per maand verzendt, je tarieven passen zich natuurlijk aan je activiteit aan.',
    tariffHighlight: 'Dynamische prijzen',
    packagingName: 'Verpakking in jouw merk',
    packagingDesc: 'Dozen, enveloppen, inserts, bijsluiters — 100% aanpasbaar.',
    packagingHighlight: 'Brand-first',
    savingsName: 'Eén all-in prijs',
    savingsDesc:
      'Transport + pick & pack in één prijs per bestelling — degressief volgens je volume.',
    savingsHighlight: 'Transparantie',
    savingsStrike1: 'Ontvangst & inslag',
    savingsStrike2: 'Opslag',
    savingsStrike3: 'WMS-abonnement',
    savingsTotalLabel: 'Transport + pick & pack',
    savingsTotalBadge: '1 prijs',
    supportName: 'EN/FR-ondersteuning 7u-22u',
    supportDesc: 'Vast aanspreekpunt in het Engels of Frans. Gratis logistieke audit.',
    supportHighlight: 'Menselijk',
    supportBadge: '2u27',
    supportBadgeLabel: 'gem. antwoord',
  },
  integrations: {
    badgeLabel: 'Integraties',
    badgeTagline: 'Centrale hub in realtime',
    headlinePart1: 'Yaslan integreert',
    headlinePart2: 'met je stack',
    headlinePart3: 'en orkestreert',
    headlinePart4: 'je leveringen',
    subhead:
      '16 e-commerce platformen synchroniseren in realtime. 30+ vervoerders activeren automatisch. Eén hub, nul config.',
    hubLabel: 'Yaslan Hub',
    benefitNoCodeTitle: 'Geen code',
    benefitNoCodeDesc:
      'Verbind je stack in 3 klikken vanuit het dashboard. Geen ontwikkelaar nodig.',
    benefitFailoverTitle: 'Vervoerder-failover',
    benefitFailoverDesc:
      'Als een vervoerder uitvalt, schakelt het systeem automatisch over naar de volgende in minder dan 1 seconde.',
    benefitWebhooksTitle: 'Webhooks in realtime',
    benefitWebhooksDesc:
      'Elke gebeurtenis (bestelling, scan, levering) activeert je automatiseringen binnen milliseconden.',
  },
  faq: {
    eyebrow: 'Veelgestelde vragen',
    heading: 'Alles wat je moet weten.',
    q1: 'Wat is Yaslan Logistiek?',
    a1: 'Yaslan is een 3PL-logistiekpartner gevestigd in België, gespecialiseerd in e-commerce. We slaan je producten op, verwerken en verzenden je bestellingen en beheren retourzendingen — zodat jij je op de verkoop kunt richten.',
    q2: 'Voor wie is Yaslan bedoeld?',
    a2: 'Voor e-commerce shops van elke omvang: van je eerste verkopen tot merken die opschalen naar duizenden bestellingen per maand. Geen minimumvolume vereist.',
    q3: 'Hoe verloopt de onboarding?',
    a3: 'In 15 minuten: we koppelen je shop (Shopify, WooCommerce, enz.), ontvangen je voorraad en je eerste bestellingen vertrekken binnen 24u. Onboarding begeleid door een toegewijde expert.',
    q4: 'Wat zijn de verzendtermijnen?',
    a4: 'Elke bestelling die vóór 15u wordt geplaatst, wordt dezelfde dag verwerkt en verzonden. Je kiest de standaardvervoerder of laat ons automatisch optimaliseren.',
    q5: 'Hoe werkt het beheer van retourzendingen?',
    a5: 'Jij bepaalt de regels (terugplaatsing in voorraad, terugbetaling, vernietiging, doorverkoop). Bij ontvangst verwerken we elke retour volgens jouw criteria en werken we je voorraad bij.',
    q6: 'Kan mijn verpakking gepersonaliseerd worden?',
    a6: 'Ja, 100%. Dozen, verzendzakken, vloeipapier, inserts, stickers, bijsluiters — alles kan jouw merk dragen. Je stuurt ons je materialen en wij voegen ze toe aan de orderverwerking.',
    q7: 'Wat is de tarifering?',
    a7: 'Betalen per gebruik, zonder maandelijks abonnement. Je betaalt maar twee dingen: het transport en de pick & pack van elke verzonden bestelling, in één all-in prijs vanaf 6,25 € excl. btw. Ontvangst, inslag, opslag, dashboard en koppelingen zijn inbegrepen, zonder kosten. De prijs varieert alleen met het pakketgewicht, je maandvolume en de omvang van je catalogus.',
    q8: 'Met welke e-commerce platformen integreren jullie?',
    a8: 'Shopify, WooCommerce, Amazon, PrestaShop, bol, BigCommerce, eBay, Etsy, Lightspeed, Magento, Odoo, Squarespace, Temu, TikTok Shop, Wix en Decathlon. Bestellingen, voorraad en verzendstatussen synchroniseren in realtime — zonder ontwikkeling aan jouw kant.',
    q9: 'Welke vervoerders zijn beschikbaar via Yaslan?',
    a9: 'Meer dan 30 geïntegreerde vervoerders: bpost, DHL, UPS, FedEx, GLS, DPD, Mondial Relay, PostNL, Colis Privé, DSV, Deutsche Post — onder andere. Onze automatische routing kiest de beste balans tussen prijs, termijn en zone volgens jouw regels.',
    q10: 'Is Yaslan geschikt voor internationale merken?',
    a10: 'Ja — ons Belgische magazijn bedient de hele Europese Unie in 24-72u. We verzenden ook naar het Verenigd Koninkrijk en Zwitserland, inclusief douanedocumentatie. We bedienen geen bestemmingen buiten Europa (Verenigde Staten, Azië, enz.) — enkel het Europese vasteland, het Verenigd Koninkrijk en Zwitserland zijn gedekt.',
    q11: 'Hoe beschermt Yaslan mijn gegevens en mijn voorraad?',
    a11: 'Magazijn onder 24/7 videobewaking met biometrische toegang, fraudebestendige verzegeling op uitgaande dozen, versleutelde back-ups van klantgegevens, AVG-conformiteit. Geautomatiseerde wekelijkse inventarissen en volledige toegang tot je dashboard.',
    q12: 'Kan ik van dienstverlener wisselen als Yaslan niet bij me past?',
    a12: 'Geen verbintenis voor bepaalde duur. Je krijgt je voorraad en je gegevens terug wanneer je maar wilt. We maken de migratie naar een andere 3PL zelfs gemakkelijk — historiek, productgegevens, vervoerderfiches — zodat jij de controle houdt.',
  },
  appMockup: {
    statusInTransit: 'Onderweg',
    statusDelivered: 'Geleverd',
    statusPreparing: 'In voorbereiding',
    splashTagline: 'Logistiek',
    loadingTitle: 'Vervoerders synchroniseren',
    loadingCarriers: 'GLS · bpost · DPD · UPS · DHL · PostNL...',
    notifDeliveredTitle: 'Pakket geleverd',
    notifDeliveredSub: 'YSL-8411 — Brussel',
    notifOrdersTitle: '+12 bestellingen',
    notifOrdersSub: 'gesynchroniseerd vanaf Shopify',
    navDashboard: 'Dashboard',
    navShipments: 'Verzendingen',
    navReturns: 'Retourzendingen',
    navStock: 'Voorraad',
    navCarriers: 'Vervoerders',
    navIntegrations: 'Integraties',
    sidebarWarehouse: 'Magazijn · België',
    sidebarOperational: 'Operationeel',
    topbarDate: 'Woensdag 23 april',
    topbarTitle: 'Overzicht',
    topbarSearch: 'Zoeken',
    topbarLive: 'Live',
    kpiShipments24h: 'Verzendingen 24u',
    kpiInTransit: 'Onderweg',
    kpiDelivered: 'Geleverd',
    kpiReturns: 'Retourzendingen',
    shipmentsTitle: 'Lopende verzendingen',
    shipmentsRealtime: 'Realtime',
    routesTitle: 'Actieve routes',
    routesRegion: 'Europa',
    carriersTitle: 'Vervoerders',
    carriersWindow: '24u',
    hubLabel: 'BE · Hub',
  },
  about: {
    breadcrumbHome: 'Home',
    breadcrumbCurrent: 'Over ons',
    heroBadge: 'Over ons · Onze bestaansreden',
    heroTitlePart1: 'Ondernemers bevrijden van',
    heroTitleHighlight: 'logistiek',
    heroSubtitle:
      'De logistieke operator bouwen die ambitieuze merken verdienden: snel, flexibel, transparant — en onzichtbaar voor de eindklant.',
    number1Value: '30+',
    number1Label: 'Begeleide merken',
    number2Value: '€ 0',
    number2Label: 'Verborgen kosten',
    number3Value: '< 4u',
    number3Label: 'Cut-off orderverwerking',
    number4Value: '99,7%',
    number4Label: 'Op tijd verzonden',
    convictionLabel: 'Onze overtuiging',
    convictionQuotePart1: 'Logistiek mag nooit een',
    convictionQuoteHighlight1: 'rem op groei',
    convictionQuotePart2: 'zijn, maar juist een',
    convictionQuoteHighlight2: 'motor',
    convictionAuthor: '— De oprichters van Yaslan',
    storyBadge: 'Onze oorsprong',
    storyTitlePart1: 'Het idee dat',
    storyTitleHighlight: 'alles veranderde',
    storyParagraph1:
      'Jarenlang zagen we getalenteerde merken afgeremd door dezelfde obstakels: vastgeklikte contracten, verborgen kosten, zwijgende vervoerders, support die na 18u nergens te vinden was. Logistiek bedacht voor zichzelf, niet voor wie ermee opgescheept zat.',
    storyQuotePart1: 'Wat als we de operator bouwden die',
    storyQuoteHighlight: 'wijzelf',
    storyQuotePart2: 'hadden willen vinden?',
    storyParagraph2Part1:
      'Yaslan is dat antwoord. Een dienst die wijkt voor het merk, die zonder beperkingen meegroeit met het volume, die in heldere taal antwoordt — op tijd, zonder jargon. Niet zomaar nóg een platform.',
    storyParagraph2Highlight: 'De operator die we zelf hadden willen hebben.',
    methodBadge: 'Onze methode · 4 stappen',
    methodTitlePart1: 'Van connectie tot',
    methodTitleHighlight: 'optimalisatie',
    step1Title: 'Connectie',
    step1Desc:
      'Automatische synchronisatie met Shopify, WooCommerce, Prestashop en Amazon in enkele minuten.',
    step2Title: 'Ontvangst',
    step2Desc:
      'Kwaliteitscontrole, telling, inslag. Je producten zijn binnen 24 uur klaar.',
    step3Title: 'Verzending',
    step3Desc: 'Picken, verpakken, labelen. Cut-off om 15u, levering vanaf de volgende dag.',
    step4Title: 'Optimalisatie',
    step4Desc:
      'Opvolging van volumes en kosten, continue bijsturing om je factuur te verlagen.',
    valuesBadge: 'Wat ons leidt',
    valuesTitlePart1: 'Drie principes,',
    valuesTitleHighlight: 'nul compromis',
    value1Title: 'Menselijk',
    value1Desc:
      'Een bereikbaar team dat je merk en je producten kent.',
    value2Title: 'Flexibel',
    value2Desc:
      'Geen minimum, geen lange verbintenis. Van je eerste pakket tot de duizenden die volgen.',
    value3Title: 'Transparant',
    value3Desc:
      'Heldere tarieven per m³ en per pakket, een realtime dashboard, geen verborgen regels.',
    ctaBadge: 'Onboarding 2026 · beperkte plaatsen',
    ctaTitlePart1: 'Wat als je logistiek',
    ctaTitleHighlight: 'verdween',
    ctaTitlePart2: 'uit je dagelijks leven?',
    ctaSubtitle:
      '30 minuten om je flow te begrijpen. Een becijferd prijsvoorstel binnen 48u. Live in minder dan een week.',
    ctaPrimary: 'Plan een gesprek van 30 min',
    ctaSecondary: 'Ontdek onze diensten',
    ctaTrust1: 'Antwoord binnen 24 werkuren',
    ctaTrust2: 'Zonder verbintenis',
    ctaTrust3: '30+ merken vertrouwen ons',
  },
  contactPage: {
    breadcrumbHome: 'Home',
    breadcrumbCurrent: 'Contact',
    badge: 'Contact · Laten we over logistiek praten',
    titlePart1: 'Laten we samen',
    titleHighlight: 'je logistiek bouwen',
    subtitlePart1: 'Vertel ons wat je nodig hebt. We komen bij je terug binnen',
    subtitleHighlight: 'minder dan 4 werkuren',
    subtitlePart2:
      ', met een eerste analyse van je flow en een richtprijs.',
    responseTitle: 'Antwoord binnen 4 werkuren',
    responseDesc:
      'Maandag tot vrijdag, van 7u tot 22u. Ons team antwoordt gemiddeld binnen 2u27.',
    emailLabel: 'E-mail',
    addressLabel: 'Adres',
    addressLine: 'Schoondonkweg 18 bus 16, 2830 Willebroek',
    addressCountry: 'België',
    followLabel: 'Volg ons',
    followDesc: 'Achter de schermen, ervaringen',
    fieldNameLabel: 'Volledige naam',
    fieldNamePlaceholder: 'Bijv. Camille Dubois',
    fieldEmailLabel: 'Professioneel e-mailadres',
    fieldEmailPlaceholder: 'jij@merk.com',
    fieldPhoneLabel: 'Telefoonnummer',
    fieldPhonePlaceholder: '+32 xxx xx xx xx',
    fieldVolumeLabel: 'Geschat maandelijks volume',
    fieldVolumePlaceholder: 'Bijv. 500 bestellingen',
    fieldStorageLabel: 'Geschatte opslagbehoefte',
    fieldStoragePlaceholder: 'Bijv. 30 m³',
    serviceLabel: 'Type dienst',
    selectPlaceholder: 'Maak je keuze',
    option1: 'Enkel opslag',
    option2: 'Opslag + orderverwerking',
    option3: 'Opslag + orderverwerking + verzending',
    option4: 'Migratie vanaf een andere 3PL',
    option5: 'Andere',
    messageLabel: 'Vertel ons over je project',
    messagePlaceholder:
      'Producten, markten, huidige vervoerders, specifieke beperkingen…',
    privacyPart1: 'Door dit formulier te versturen ga je akkoord met ons',
    privacyLink: 'privacybeleid',
    privacyPart2: '. Geen spam, geen doorverkoop, nooit.',
    submitting: 'Versturen…',
    submit: 'Verstuur mijn aanvraag',
    errorGeneric: 'Er is iets misgegaan. Probeer het opnieuw.',
    errorNetwork:
      'Het formulier kon niet worden verstuurd. Controleer je verbinding en probeer opnieuw.',
    trust1: 'Antwoord binnen 4 werkuren',
    trust2: 'Geen verbintenis',
    trust3: 'Gratis audit',
    successTitle: 'Aanvraag ontvangen.',
    successDescPart1: 'Een teamlid komt bij je terug binnen',
    successDescHighlight: '4 werkuren',
    successDescPart2: 'met een eerste analyse van je flow.',
    successReset: '← Verstuur nog een aanvraag',
    tabCall: 'Boek een gesprek',
    tabCallHint: '30 min · videogesprek',
    tabQuote: 'Offerte aanvragen',
    tabQuoteHint: '2 min · becijferde inschatting',
    callTitle: 'Kies je moment',
    callDesc:
      'Dertig minuten videogesprek met een logistiek expert. We bekijken je huidige flow en zeggen eerlijk of Yaslan de juiste partner is.',
    callLoading: 'Kalender laden…',
    callFallback:
      'Kalender niet zichtbaar? Je browser blokkeert mogelijk het script. Open hem in een nieuw tabblad:',
  },
  blog: {
    badgeName: 'Yaslan blog',
    badgeTopic: 'Logistiek & e-commerce',
    heroTitleLine1: 'De blog voor webshops die',
    heroTitleHighlight: 'beter leveren',
    heroSubtitle:
      'Advies, casestudy’s en analyses om je logistiek te optimaliseren, de juiste vervoerders te kiezen en je e-commerce te schalen.',
    categories: {
      all: 'Alles',
      logistics: 'Logistiek',
      ecommerce: 'E-commerce',
      delivery: 'Levering',
      technology: 'Technologie',
      sustainability: 'Duurzaamheid',
    },
    filterAll: 'Alles',
    countSingular: '{count} artikel',
    countPlural: '{count} artikelen',
    byline: 'Door {name}',
    readTime: '{n} min leestijd',
    readTimeShort: '{n} min',
    featured: 'Uitgelicht',
    readArticle: 'Lees het artikel',
    allArticlesTitle: 'Alle artikelen',
    allArticlesCaption: 'Elke week gepubliceerd',
    emptyState: 'Nog geen artikelen in deze categorie.',
    newsletterBadge: 'Wekelijkse nieuwsbrief',
    newsletterTitleLine1: 'Ontvang onze beste artikelen',
    newsletterTitleHighlight: 'rechtstreeks in je inbox',
    newsletterCopy:
      'Eén e-mail per week. Casestudy’s, vervoerdersbenchmarks en best practices om je e-commerce te schalen. Geen spam.',
    newsletterEmailLabel: 'E-mailadres',
    newsletterPlaceholder: 'jij@bedrijf.com',
    newsletterSubmit: 'Abonneren',
    newsletterSubmitted: 'Ingeschreven!',
    newsletterPrivacy:
      'Door je in te schrijven ga je akkoord met ons privacybeleid. Uitschrijven met één klik.',
    newsletterSocialProofPart1: 'Al gevolgd door',
    newsletterSocialProofCount: '1.200+',
    newsletterSocialProofPart2: 'webshops',
    article: {
      notFoundTitle: 'Artikel niet gevonden',
      notFoundLink: '← Terug naar de blog',
      breadcrumbHome: 'Home',
      breadcrumbBlog: 'Blog',
      contentUnavailable:
        'De inhoud van dit artikel is nog niet beschikbaar. Kom binnenkort terug!',
      relatedHeading: 'Lees verder',
      ctaBadge: 'Logistieke audit · 30 min · gratis',
      ctaTitleLead: 'Wat als je logistiek',
      ctaTitleHighlight: 'verdween',
      ctaTitleTail: 'uit je dagelijkse werk?',
      ctaCopy:
        'Dertig minuten om je flow te begrijpen. Een becijferd prijsvoorstel binnen 48 u. Operationeel in minder dan een week.',
      ctaPrimary: 'Plan een gesprek van 30 min',
      ctaSecondary: '← Alle artikelen',
      trust1: 'Antwoord binnen 24 werkuren',
      trust2: 'Vrijblijvend',
    },
  },
  sectorsPage: {
    breadcrumbHome: 'Home',
    breadcrumbCurrent: 'Sectoren',
    badge: 'Sectoren · Logistiek op maat',
    h1Lead: 'Logistiek ontworpen voor',
    h1Highlight: 'jouw sector',
    intro:
      'Mode, cosmetica, elektronica, buiten & tuin, wonen & decoratie, parfumerie — elke sector legt zijn eigen beperkingen op: naleving, breekbaarheid, seizoensgebondenheid, traceerbaarheid, unboxing. Yaslan past zijn procedures, zijn verpakking en zijn vervoerdersnetwerk aan jouw markt aan om je een meetbaar operationeel voordeel te geven.',
    number1Value: '6',
    number1Label: 'Beheerste sectoren',
    number2Value: '30+',
    number2Label: 'Begeleide merken',
    number3Value: '€ 0',
    number3Label: 'Verborgen kosten',
    gridTitleLead: 'Zes sectoren,',
    gridTitleHighlight: 'één toegewijde expertise',
    gridCaption:
      'Klik op je sector om onze aanpak, onze garanties en de concrete antwoorden te ontdekken die we bieden op je operationele beperkingen.',
    cardCta: 'Ontdekken',
    whyBadge: 'Waarom een gespecialiseerde 3PL?',
    whyTitleLead: 'Een generieke 3PL',
    whyTitleHighlight: 'vertraagt je',
    whyPara1:
      'Je e-commerce logistiek uitbesteden aan een 3PL-operator heeft alleen zin als die operator je markt kent. Een dienstverlener die textiel en elektronica op dezelfde manier behandelt, past gemiddelde procedures toe die gemiddelde resultaten opleveren — slecht beheerde retourgraad, stijgende breuk, twijfelachtige naleving.',
    whyPara2:
      'Yaslan is een Belgische e-commerce 3PL die zijn procedures per sector heeft gestructureerd: een ADR-kanaal voor parfumerie, traceerbaarheid per lot voor cosmetica, IMEI-serialisatie voor elektronica, elastische capaciteit voor modedrops, zwaar transport voor tuin, schokbestendige opvulling voor decoratie. Dat zijn afzonderlijke vaardigheden, niet één en hetzelfde proces opnieuw geschilderd.',
    whyPara3:
      'Het resultaat: een beheerste logistieke kost zonder verborgen kosten, breukgraden gedeeld door vijf op gevoelige producten, en een klantervaring die de toon van je merk respecteert — van doos tot vervoerder.',
    ctaBadge: 'Logistieke audit · 30 min · gratis',
    ctaTitleLead: 'En als je logistiek',
    ctaTitleHighlight: 'zou verdwijnen',
    ctaTitleTail: ' uit je dagelijks leven?',
    ctaCopy:
      '30 minuten om je flow te begrijpen. Een becijferd prijsvoorstel binnen 48u. Een opstart in minder dan een week.',
    ctaPrimary: 'Boek een gesprek van 30 min',
    ctaSecondary: 'Meer weten over Yaslan',
    trust1: 'Antwoord binnen 24 werkuren',
    trust2: 'Zonder verbintenis',
    trust3: '200+ merken vertrouwen ons',
  },
  sectorPage: {
    notFoundTitle: 'Sector niet gevonden',
    notFoundLink: '← Bekijk alle sectoren',
    breadcrumbHome: 'Home',
    breadcrumbSectors: 'Sectoren',
    badgeSuffix: ' · gespecialiseerde 3PL',
    challengesHeadingLead: 'De logistieke uitdagingen van',
    challengesConstat: 'De vaststelling',
    challengesResponse: 'Ons antwoord',
    flowHeadingLead: 'De Yaslan-flow voor',
    flowIntro:
      'Drie stations aangestuurd door ons team en onze systemen — elk stuk gaat door de controles die specifiek zijn voor jouw sector, zonder tijdverlies.',
    promiseKicker: 'Onze belofte',
    statsBadge: 'Becijferde verbintenissen',
    statsHeadingLead: 'Waarom kiezen voor Yaslan voor',
    seasonalHeadingLead: 'Je seizoenspieken,',
    seasonalHeadingHighlight: 'opgevangen zonder onderbreking',
    seasonalIntro:
      'Elastische capaciteit en vooraf geplande operationele versterkingen — je hoogseizoen wordt nooit je breekpunt.',
    faqHeadingLead: 'Veelgestelde vragen —',
    faqHeadingHighlight: 'logistiek voor {sector}',
    otherSectors: 'Andere sectoren',
    ctaBadge: 'Audit {sector} · 30 min · gratis',
    ctaTitleLead: 'En als je logistiek',
    ctaTitleHighlight: 'zou verdwijnen',
    ctaTitleTail: ' uit je dagelijks leven?',
    ctaCopy:
      '30 minuten om je {sector}-catalogus en je seizoensgebondenheid te begrijpen. Een becijferd prijsvoorstel binnen 48u. Een opstart in minder dan een week.',
    ctaPrimary: 'Boek een gesprek van 30 min',
    ctaSecondary: '← Alle sectoren',
    trust1: 'Antwoord binnen 24 werkuren',
    trust2: 'Zonder verbintenis',
    trust3: '200+ merken vertrouwen ons',
  },
  servicePage: {
    seoTitle: '{service} e-commerce in België | Yaslan 3PL',
    notFoundTitle: 'Dienst niet gevonden',
    backToHome: '← Terug naar home',
    breadcrumbHome: 'Home',
    flowHeadingLead: 'Zo werkt jouw',
    flowIntro:
      'Drie stations aangestuurd door ons team en onze systemen — elke stap gaat door de controles die specifiek zijn voor de dienst, zonder tijdverlies.',
    statsBadge: 'Becijferde verbintenissen',
    statsHeadingLead: 'Drie cijfers die',
    statsHeadingHighlight: 'alles veranderen',
    promiseKicker: 'Onze belofte',
    featuresHeadingLead: 'Alles wat',
    featuresHeadingHighlight: 'inbegrepen is',
    faqHeadingLead: 'Veelgestelde vragen —',
    otherServicesHeading: 'Ook:',
    otherServicesLink: 'Ontdekken',
    ctaBadge: 'Audit {service} · 30 min · gratis',
    ctaTitleLead: 'En als je logistiek',
    ctaTitleHighlight: 'zou verdwijnen',
    ctaTitleTail: ' uit je dagelijks leven?',
    ctaCopy:
      '30 minuten om je flow te begrijpen. Een becijferd prijsvoorstel binnen 48u. Een opstart in minder dan een week.',
    ctaPrimary: 'Boek een gesprek van 30 min',
    trust1: 'Antwoord binnen 24 werkuren',
    trust2: 'Zonder verbintenis',
    trust3: '30+ merken vertrouwen ons',
  },
  cookieBanner: {
    dialogAriaLabel: 'Cookietoestemmingsbanner',
    eyebrow: 'Cookies',
    bannerTitle: 'Jouw privacy, jouw keuzes',
    bannerBody:
      'We gebruiken alleen cookies die strikt noodzakelijk zijn voor de werking van de site. Met jouw toestemming meten we ook anoniem het bezoek om onze content te verbeteren.',
    learnMore: 'Meer informatie',
    customize: 'Aanpassen',
    reject: 'Weigeren',
    accept: 'Accepteren',
    closeAria: 'Sluiten',
    prefsEyebrow: 'Cookievoorkeuren',
    prefsTitle: 'Mijn cookies beheren',
    prefsIntro:
      'Kies welke categorieën cookies je toestaat. Je voorkeuren worden 6 maanden bewaard en kunnen op elk moment worden gewijzigd.',
    necessaryTitle: 'Strikt noodzakelijk',
    necessaryDesc:
      'Onmisbaar voor de werking van de site (het onthouden van je toestemmingskeuzes). Altijd actief.',
    necessaryBadge: 'Actief',
    analyticsTitle: 'Bezoekmeting',
    analyticsDesc:
      'Helpt ons anoniem te begrijpen hoe onze site wordt gebruikt. Geen advertentieprofilering.',
    rejectAll: 'Alles weigeren',
    save: 'Opslaan',
    acceptAll: 'Alles accepteren',
    prefsFooterPart1: 'Meer informatie in ons',
    prefsFooterLink: 'Cookiebeleid',
  },
  breadcrumb: {
    adr: 'ADR',
    afsca: 'FAVV',
    home: 'Home',
    about: 'Over ons',
    sectors: 'Sectoren',
    blog: 'Blog',
    contact: 'Contact',
    cookies: 'Cookiebeleid',
    legal: 'Juridische kennisgeving',
    privacy: 'Privacybeleid',
    terms: 'Algemene voorwaarden',
  },
  adrPage: {
    // ── Hero ──
    badge: 'Gevaarlijke goederen · ADR',
    h1Lead: 'Sla je',
    h1Highlight: 'gevaarlijke goederen',
    h1Tail: ' voor e-commerce op en verzend ze.',
    subhead:
      'Lithiumbatterijen, spuitbussen, ontvlambare en bijtende stoffen, alcoholhoudende cosmetica… Wij beschikken over een ADR-opslagvergunning en verzenden je gevoelige producten overal in Europa — daar waar de meeste 3PL-partners en e-commercesoftware weigeren.',
    ctaPrimary: 'Gratis audit',
    reassure: 'Antwoord binnen 4 werkuren · Zonder abonnement',
    // ── Hook différenciant ──
    hook: {
      eyebrow: 'Wat ons onderscheidt',
      title: 'Wat de meeste 3PL-partners weigeren te beheren',
      lead: 'De meeste logistieke dienstverleners en e-commerceplatforms blokkeren gevaarlijke goederen al bij de productfiche. Wij slaan ze op en verzenden ze wél.',
      points: [
        'Een magazijn met een ADR-opslagvergunning, geen gewone stelling.',
        'ADR-erkende vervoerders voor je B2B-zendingen in volume.',
        'Een conform kader, van de opslag tot de eindlevering.',
      ],
    },
    // ── Scope OUI / NON ──
    scope: {
      eyebrow: 'Bereik',
      title: 'Wat we wel beheren en wat we niet beheren',
      statement:
        'Gevaarlijke goederen betekenen geen geweigerde goederen: valt het binnen onze ADR-scope, dan slaan we het op en verzenden we het — zo niet, dan zeggen we het je duidelijk.',
      yesTitle: 'Wij slaan op & verzenden',
      yes: [
        'Lithiumbatterijen en -cellen',
        'Spuitbussen en sprays onder druk',
        'Ontvlambare vloeistoffen',
        'Bijtende producten',
        'Alcoholhoudende cosmetica (parfums…)',
        'Onderhoudsproducten',
      ],
      noTitle: 'Buiten bereik',
      no: [
        'Explosieven (klasse 1)',
        'Radioactieve stoffen (klasse 7)',
      ],
      note: 'Twijfel je over je product? Stuur ons de veiligheidsinformatieblad (FDS/SDS): we geven je een duidelijk antwoord, ja of nee.',
    },
    // ── Comment ça marche ──
    how: {
      eyebrow: 'Hoe het werkt',
      title: 'Van opslag tot verzending, twee beheerste stromen',
      steps: [
        {
          title: 'Conforme opslag',
          desc: 'Je gevaarlijke goederen worden onder ADR-vergunning opgeslagen, gescheiden en aangeduid volgens hun klasse.',
        },
        {
          title: 'B2C-zending',
          desc: 'Eén product, één bestemming: we verzenden via de vervoerders van ons gebruikelijke netwerk, binnen de toegestane hoeveelheden.',
        },
        {
          title: 'B2B-zending in volume',
          desc: 'Vanaf ~2 paletten werken we met een ADR-erkende vervoerder: DSV.',
        },
      ],
    },
    // ── Conformité & garanties ──
    compliance: {
      eyebrow: 'Conformiteit & garanties',
      title: 'Een reglementair kader, geen grijze zone',
      items: [
        {
          title: 'ADR-opslagvergunning',
          desc: 'Ons magazijn is gemachtigd om gevaarlijke e-commercegoederen op te slaan in de klassen die wij beheren.',
        },
        {
          title: 'Erkende vervoerders',
          desc: 'Voor B2B in volume werken we met DSV, erkend voor ADR-transport.',
        },
        {
          title: 'Verpakking & etikettering',
          desc: 'Markering, gevaarsetiketten en transportdocumenten conform bij elke zending.',
        },
        {
          title: 'Scheiding van klassen',
          desc: 'Onverenigbare producten worden gescheiden opgeslagen om elk risico te vermijden.',
        },
      ],
    },
    // ── FAQ (longue traîne SEO) ──
    faqEyebrow: 'FAQ',
    faqTitle: 'Je vragen over ADR-opslag',
    faq: [
      {
        q: 'Wat is ADR en wie is betrokken in e-commerce?',
        a: 'ADR is het Europese akkoord betreffende het internationale vervoer van gevaarlijke goederen over de weg. In e-commerce betreft het alle producten die als gevaarlijk zijn ingedeeld: lithiumbatterijen, spuitbussen, parfums, ontvlambare of bijtende producten… Zodra een van deze artikelen wordt opgeslagen en vervolgens verzonden, is een ADR-kader van toepassing.',
      },
      {
        q: 'Kunnen jullie lithiumbatterijen opslaan voor mijn webshop?',
        a: 'Ja. Lithiumbatterijen en -cellen behoren tot de gevaarlijke goederen die wij onder ADR-vergunning opslaan en verzenden, zowel B2C als B2B, met respect voor de reglementaire hoeveelheden en verpakkingen.',
      },
      {
        q: 'Welke gevaarlijke producten kunnen jullie niet beheren?',
        a: 'Wij beheren geen explosieven (klasse 1) noch radioactieve stoffen (klasse 7), die buiten het e-commercebereik vallen. Voor al de rest — lithium, spuitbussen, ontvlambare en bijtende stoffen, alcoholhoudende cosmetica — stuur ons het veiligheidsinformatieblad en wij bevestigen of we het kunnen behandelen.',
      },
      {
        q: 'Hoe verzenden jullie gevaarlijke goederen in B2C?',
        a: 'Voor een enkele zending (één product naar één bestemming) verzenden we via de vervoerders van ons gebruikelijke netwerk, binnen de hoeveelheidslimieten die gelden voor pakketten met gevaarlijke goederen.',
      },
      {
        q: 'En voor B2B-volumes (meerdere paletten)?',
        a: 'Vanaf ongeveer twee paletten werken we met een ADR-erkende vervoerder — DSV — die over de nodige middelen en certificaten beschikt voor het vervoer van gevaarlijke goederen in volume.',
      },
      {
        q: 'Is er een specifieke verpakking nodig voor ADR-producten?',
        a: 'Ja. Elke zending van gevaarlijke goederen vereist een goedgekeurde verpakking, een conforme markering en gevaarsetiketten, evenals de juiste transportdocumenten. Wij nemen dat voor onze rekening.',
      },
      {
        q: 'Leveren jullie gevaarlijke goederen overal in Europa?',
        a: 'Ja, we verzenden in Europa, het Verenigd Koninkrijk en Zwitserland. De exacte voorwaarden hangen af van de productklasse, de hoeveelheid en de bestemming — we bevestigen elk geval tijdens de audit.',
      },
    ],
    // ── Libellés d'animations (composants bespoke) ──
    anim: {
      diamond: {
        badge: 'Beheerde klassen',
        classes: ['Lithium', 'Spuitbussen', 'Ontvlambaar', 'Bijtend'],
      },
      sort: {
        badge: 'Conformiteitssortering',
        accepted: 'Aanvaard',
        rejected: 'Buiten bereik',
      },
      split: {
        badge: 'Twee stromen',
        stored: 'ADR-voorraad',
        b2c: 'B2C',
        b2cDesc: '1 product → 1 klant',
        b2b: 'B2B',
        b2bDesc: 'Volumes · paletten',
        carriers: 'DSV',
      },
    },
  },
  afscaPage: {
    // ── Hero ──
    badge: 'Voedingsmiddelen · FAVV',
    h1Lead: 'Je voedingsopslag,',
    h1Highlight: 'FAVV-geregistreerd',
    h1Tail: '.',
    subhead:
      'Supplementen, niet-bederfelijke dranken, thee, droge kruidenierswaren… Wij zijn geregistreerd bij het FAVV voor opslag op kamertemperatuur, met FEFO-rotatie, datumbeheer en lottraceerbaarheid.',
    ctaPrimary: 'Gratis audit',
    reassure: 'Antwoord binnen 4 werkuren · Zonder abonnement',
    // ── Hook différenciant ──
    hook: {
      eyebrow: 'Wat ons onderscheidt',
      title: 'De foodlogistiek die veel 3PL-partners vermijden',
      lead: 'Het opslaan van voedingsmiddelen vereist een kader dat weinig e-commercedienstverleners op zich nemen. Wij wel — voor producten op kamertemperatuur.',
      points: [
        'FAVV-registratie voor opslag op kamertemperatuur.',
        'FEFO-rotatie en beheer van DLC/DDM, geen blinde first-in-first-out.',
        'Lottraceerbaarheid en terugroepvermogen.',
      ],
    },
    // ── Scope OUI / NON ──
    scope: {
      eyebrow: 'Bereik',
      title: 'Wat we wel opslaan en wat we niet opslaan',
      yesTitle: 'Wij slaan op (ambient)',
      yes: [
        'Voedingssupplementen',
        'Niet-bederfelijke dranken (water…)',
        'Thee en kruidenthee',
        'Droge kruidenierswaren',
        'Voorverpakte ambient producten',
      ],
      noTitle: 'Buiten bereik',
      no: [
        'Verse producten (0–8 °C)',
        'Diepvriesproducten',
        'Dierenvoeding',
      ],
      note: 'Wij slaan uitsluitend op kamertemperatuur op: geen koelketen, geen diepvries, geen petfood.',
    },
    // ── Gestion du stock ──
    how: {
      eyebrow: 'Voorraadbeheer',
      title: 'Een foodbeheer, geen simpel inpakken in dozen',
      steps: [
        {
          title: 'Ontvangst & controle',
          desc: 'Bij binnenkomst registreren we de loten en de vervaldatums (DLC/DDM).',
        },
        {
          title: 'FEFO-rotatie',
          desc: 'First Expired, First Out: de producten waarvan de datum nadert, vertrekken het eerst.',
        },
        {
          title: 'Lottraceerbaarheid',
          desc: 'Elke zending is gekoppeld aan haar lot — onmisbaar bij een terugroeping.',
        },
      ],
    },
    // ── Conformité & garanties ──
    compliance: {
      eyebrow: 'Conformiteit & garanties',
      title: 'Het FAVV-kader, concreet',
      items: [
        {
          title: 'FAVV-registratie',
          desc: 'Wij zijn geregistreerd bij het FAVV voor de opslag van voedingsmiddelen op kamertemperatuur.',
        },
        {
          title: 'FEFO & datumbeheer',
          desc: 'Rotatie gestuurd door de DLC/DDM om verliezen te vermijden en producten binnen hun houdbaarheid te leveren.',
        },
        {
          title: 'Lottraceerbaarheid',
          desc: 'Opvolging van de loten van ontvangst tot verzending, om snel te reageren bij een terugtrekking of terugroeping.',
        },
        {
          title: 'Hygiëne & scheiding',
          desc: 'Propere, droge en geordende opslag, gescheiden van niet-voedingsgoederen.',
        },
      ],
    },
    // ── FAQ (longue traîne SEO) ──
    faqEyebrow: 'FAQ',
    faqTitle: 'Je vragen over voedingsopslag',
    faq: [
      {
        q: 'Wat is het FAVV en waarom is het belangrijk om voeding online te verkopen?',
        a: 'Het FAVV is het Belgische Federaal Agentschap voor de Veiligheid van de Voedselketen. Elk bedrijf dat voedingsmiddelen opslaat of behandelt, moet bij het FAVV gekend zijn. Je voorraad toevertrouwen aan een FAVV-geregistreerde dienstverlener garandeert dat je producten in een gecontroleerd kader worden opgeslagen.',
      },
      {
        q: 'Welke voedingsproducten kunnen jullie opslaan?',
        a: 'Wij slaan voedingsmiddelen op kamertemperatuur op: voedingssupplementen, niet-bederfelijke dranken, thee en kruidenthee, droge kruidenierswaren en voorverpakte producten. Alles wat noch koeling noch diepvries vereist.',
      },
      {
        q: 'Slaan jullie verse of diepgevroren producten op?',
        a: 'Nee. Onze registratie dekt uitsluitend opslag op kamertemperatuur. Wij beheren noch de koelketen (0–8 °C), noch diepvriesproducten, noch dierenvoeding.',
      },
      {
        q: 'Hoe beheren jullie de vervaldatums (DLC/DDM)?',
        a: 'Vanaf de ontvangst registreren we de datums en passen we een FEFO-rotatie toe (First Expired, First Out): de producten waarvan de datum nadert, worden bij voorrang verzonden, wat de verliezen beperkt en producten binnen hun houdbaarheid garandeert.',
      },
      {
        q: 'Verzorgen jullie lottraceerbaarheid?',
        a: 'Ja. Elk product is gekoppeld aan zijn lot, van ontvangst tot verzending. Bij een terugtrekking of terugroeping identificeren we snel de betrokken bestellingen.',
      },
      {
        q: 'Wat gebeurt er bij een productterugroeping?',
        a: 'Dankzij de lottraceerbaarheid kunnen we de betrokken voorraad isoleren en de bestellingen identificeren die het geviseerde lot hebben ontvangen, om zo snel mogelijk een terugtrekking of terugroeping uit te voeren.',
      },
      {
        q: 'Wat is het verschil tussen DLC en DDM?',
        a: 'De DLC (uiterste consumptiedatum (TGT), "te gebruiken tot") betreft bederfelijke producten; de DDM (houdbaarheidsdatum (THT), "ten minste houdbaar tot") betreft stabiele producten zoals droge kruidenierswaren. Wij beheren beide in onze rotatie.',
      },
    ],
    // ── Libellés d'animations (composants bespoke) ──
    anim: {
      shield: {
        badge: 'FAVV',
        label: 'Conform',
      },
      gauge: {
        badge: 'Temperatuur',
        ambient: 'Ambient',
        chilled: 'Vers',
        frozen: 'Diepvries',
      },
      fefo: {
        badge: 'FEFO',
        title: 'First Expired, First Out',
        next: 'Vertrekt het eerst',
        lot: 'Lot getraceerd',
      },
    },
  },
  devisWizard: {
    badge: 'Gratis offerte & audit',
    title: 'Schat je logistieke behoeften in',
    subtitle:
      'In 1 minuut: ontvang je gepersonaliseerde inschatting en boek 15 min met een Yaslan-expert.',
    progress: { step1: 'Producten', step2: 'Volumes', step3: 'Gegevens', step4: 'Afspraak' },
    nav: { prev: 'Vorige', next: 'Volgende', seeEstimate: 'Bekijk mijn inschatting' },
    step1: {
      title: 'Je producten',
      sectorLabel: 'Je sector?',
      sourcingLabel: 'Waar worden je producten gemaakt / ingekocht?',
      basketLabel: 'Gemiddelde bestelwaarde',
    },
    step2: {
      title: 'Je volumes & levering',
      ordersLabel: 'Bestellingen per maand',
      itemsLabel: 'Gemiddeld aantal artikelen per pakket',
      weightLabel: 'Gemiddeld gewicht per artikel',
      splitLabel: 'Gewenste leveringsverdeling',
      splitHome: 'Thuislevering',
      splitPickup: 'Afhaalpunt',
      zonesLabel: 'Leveringszones',
    },
    step3: {
      title: 'Je gegevens',
      nameLabel: 'Volledige naam',
      namePh: 'Jan Janssens',
      emailLabel: 'Professioneel e-mailadres',
      emailPh: 'jij@bedrijf.com',
      phoneLabel: 'Telefoon',
      phonePh: '+32 4XX XX XX XX',
      websiteLabel: 'Website',
      websitePh: 'jouw-webshop.com',
      platformLabel: 'E-commerceplatform',
      platformPh: 'Maak een keuze…',
      privacy:
        'Je gegevens dienen uitsluitend om je offerte voor te bereiden. Geen doorverkoop, geen spam.',
    },
    sectors: {
      mode: 'Mode & Textiel',
      cosmetique: 'Cosmetica & Beauty',
      parfumerie: 'Parfumerie',
      maison: 'Wonen & Deco',
      jardin: 'Tuin & Buiten',
      electronique: 'Elektronica',
      food: 'Supplementen / Food',
      autre: 'Andere',
    },
    sourcing: {
      import: 'Geïmporteerd (Azië / China)',
      ue: 'EU / Europa',
      local: 'België / lokaal',
      mix: 'Mix',
    },
    zones: {
      be: 'België',
      eu: 'Europa',
      uk: 'Verenigd Koninkrijk',
      ch: 'Zwitserland',
      world: 'Wereldwijd',
    },
    platforms: {
      shopify: 'Shopify',
      woocommerce: 'WooCommerce',
      prestashop: 'PrestaShop',
      magento: 'Magento',
      amazon: 'Amazon',
      other: 'Andere / geen',
    },
    units: {
      basket: '€',
      orders: 'bestellingen / maand',
      items: 'artikelen',
      weight: 'g',
    },
    booking: {
      teaserTitle: 'Je gepersonaliseerde inschatting is klaar',
      teaserDesc:
        'Boek 30 minuten met een expert om ze in detail te ontvangen en je offerte op maat te krijgen.',
      calFallback: 'Lukt het niet om de kalender te tonen? Open hem in een nieuw tabblad.',
      bookedTitle: 'Geboekt!',
      bookedDesc:
        'We hebben je brief goed ontvangen — we bereiden je inschatting voor de afspraak voor. Tot snel!',
    },
    error: {
      required: 'Vul de verplichte velden in (naam, e-mail, telefoon).',
      briefFailed: 'Je aanvraag is goed ontvangen; boek hieronder je tijdslot.',
    },
  },
  seo: {
    adr: {
      title: 'ADR-opslag — gevaarlijke e-commercegoederen — Yaslan',
      description:
        'Yaslan slaat uw gevaarlijke e-commercegoederen op en verzendt ze (lithiumbatterijen, spuitbussen, ontvlambare…) met ADR-opslagvergunning. B2C elke vervoerder, B2B via DSV.',
    },
    afsca: {
      title: 'FAVV-opslag — ambient e-commerce voedingslogistiek — Yaslan',
      description:
        'Yaslan, FAVV-geregistreerd, slaat uw voedingsproducten op kamertemperatuur op (supplementen, dranken, droge kruidenierswaren) met FEFO-rotatie, THT-beheer en lottraceerbaarheid.',
    },
    home: {
      // Keyword-first, brand last. GSC (3 mo to 2026-07-26): `e-commerce logistiek`
      // ranked at avg position 1.91 on 137 impressions for ZERO clicks — at that
      // position the expected CTR is 10-15%. The cause was a brand-first title:
      // "Yaslan —" ate the first 7 characters on a head query where nobody knows
      // the brand yet, so the exact query only appeared after a dash. The
      // differentiator ("geen abonnement", the one thing this market has no other
      // answer for) was last in the description instead of in the title.
      title: 'E-commerce logistiek België — zonder abonnement | Yaslan',
      description:
        'E-commerce logistiek vanuit Willebroek: opslag, pick & pack en verzending binnen 24 u. Geen abonnement, geen minimumvolume. Prijs binnen 4 werkuren.',
    },
    about: {
      title: 'Over Yaslan — 3PL e-commerce logistiek in België',
      description:
        'Ontdek Yaslan: een Belgische 3PL-logistiekpartner gespecialiseerd in e-commerce. Onze missie, onze methode in 4 stappen en onze belofte om logistiek uit je dagelijks leven te laten verdwijnen.',
    },
    contactPage: {
      title: 'Contacteer Yaslan — 3PL e-commerce logistiek in België',
      description:
        'Praat met ons logistiek team. Antwoord binnen 4 werkuren en een gratis audit van je e-commerce flow. Gevestigd in Willebroek, leveringen in Europa, het VK en Zwitserland.',
    },
    blog: {
      title: 'E-commerce logistiek blog — Tips & trends — Yaslan',
      description:
        'Praktische tips, trendanalyses en inzichten uit het veld over e-commerce logistiek, 3PL-orderverwerking en retourbeheer in Europa.',
    },
    sectors: {
      title: 'E-commerce logistiek per sector — Yaslan',
      description:
        'Op maat gemaakte 3PL-oplossingen voor jouw sector: mode, cosmetica, elektronica, buiten & tuin, wonen & decoratie, parfumerie. Opslag, orderverwerking en verzending binnen 24u in Europa vanuit België.',
    },
  },
}
